import { EnumBase } from '@core/models/enum-base.model';

export class TipoReadaptacao extends EnumBase {
  constructor() {
    super([
        { value: 'DEFINITIVA', name: 'Definitiva' },
        { value: 'PROVISORIA', name: 'Provisória' },
    ]);
  }
}
